module.exports = __webpack_public_path__ + "img/12.81dbd0e9.png";